import { IPublicClientApplication } from "@azure/msal-browser";
import { TokenAccess } from "../../../Interfaces/Login/LoginInterface";
import {
    FazerLoginADService,
    FazerLoginOrganizacaoADService,
    GetTokenMSAL,
} from "../../../Services/Login/LoginAD/LoginADServices";
import { Controller } from "../../Controller";

export async function LoginMSAL(instance: IPublicClientApplication) {
    return GetTokenMSAL(instance).then((tokenObj) => {
        return tokenObj.accessToken;
    });
}

export async function FazerLoginADController(token: string, ID_ORG: string) {
    return Controller(FazerLoginADService(token, ID_ORG)).then(
        (response: TokenAccess) => {
            const token = response.Token;
            localStorage.setItem("@token", token);
            return token;
        }
    );
}

export function FazerLoginOrganizacaoADController(token: string) {
    return Controller(FazerLoginOrganizacaoADService(token));
}
